export const setOrderFreeIssuePromotionDetails = (orderPromotionDetail) => ({
    type: 'SET_ORDER_FREE_ISSUE_PROMOTIONS',
    payload: orderPromotionDetail
});

export const resetOrderFreeIssuePromotionDetails = () => ({
    type: 'RESET_ORDER_FREE_ISSUE_PROMOTIONS'
});